<template>
  <div class="sticky top-10">
    <Preview :data="data" />
  </div>
</template>

<script>
import Preview from "@/components/Tiktok/Preview";

export default {
  components: { Preview },
  props: {
    data: Object,
  },
};
</script>

<style></style>
